// @utilities
const { APIGet } = require('utilities/APIRequestHelper')

const getFiocInformation = () => {
   return APIGet({ endpoint: 'fiocInformation' })
    .then((response) => response)
    .catch(() => {})
}

export {
    getFiocInformation
}